import { createSelector } from 'reselect';
import { AppState } from 'store/AppState';

export const footerSelector = (state: AppState): any => state.brochureWare.footer;
export const histryStateSelector = (state: AppState): any => state.router.location;

export const getBusinessFooterContent = createSelector(footerSelector, (footer) => footer.content);
export const getHistryState = createSelector(histryStateSelector, (history) => history);
